/**
 *
 * @param {*} products [{ priceOut, quantity, discount }]
 * @param {*} discountAll
 * @returns
 */
export const calculateTotalInvoice = (products = [], discountAll = '0') => {
  if (!products.length) return { total: 0, reduction: 0, mustPay: 0 };

  const discountAllValue = Number(discountAll) || 0;

  // Calculate the total value of all products before applying discounts
  const result = products.reduce(
    (prev, curr) => {
      const priceOut = Number(curr.priceOut) || 0;
      const quantity = Number(curr.quantity) || 0;
      const productDiscount = Number(curr.discount) || 0;

      const productTotal = priceOut * quantity;

      let productReduction = 0;

      // Apply discount for each product
      if (productDiscount >= 1000) {
        productReduction += productDiscount * quantity;
      } else {
        productReduction += (priceOut * productDiscount * quantity) / 100;
      }

      return {
        total: prev.total + productTotal,
        reduction: prev.reduction + productReduction,
      };
    },
    {
      total: 0,
      reduction: 0,
    },
  );

  // Apply invoice discount if available
  let invoiceReduction = 0;
  if (discountAllValue) {
    if (discountAllValue >= 1000) {
      invoiceReduction = discountAllValue;
    } else {
      invoiceReduction = (result.total * discountAllValue) / 100;
    }
  }

  return {
    total: result.total,
    reduction: result.reduction + invoiceReduction,
    mustPay: result.total - result.reduction - invoiceReduction,
  };
};
